import { createSignal, type JSX, onCleanup, onMount } from "solid-js";
import type { VideoEvidence } from "../../ChatEventTypes";
import "./VideoPanelContent.css";
import type { AppLayoutKind } from "@ui/layouts/layoutProvider";
import { effect } from "solid-js/web";
import { VideoPanelCarousel } from "./VideoPanelCarousel/VideoPanelCarousel";

type Props = {
	videoIndex: number;
	videoEvidence: VideoEvidence[];
	boardId?: string;
	projectId?: string;
	onClose: () => void;
	onVideoIndexChange?: (index: number) => void;
	showAddToBoardButton?: boolean;
	class?: string;
	style?: JSX.CSSProperties;
	conversationDataAppKind?: AppLayoutKind;
	autoPlay?: boolean;
};

export const VideoPanelContent = (props: Props) => {
	const [activeCarouselSlide, setActiveCarouselSlide] = createSignal<
		number | null
	>(props.videoIndex);
	effect(() => {
		setActiveCarouselSlide(props.videoIndex);
	});

	onMount(() => {
		const onKeyDown = (event: KeyboardEvent) => {
			if (event.key !== "Escape") {
				return;
			}
			event.stopImmediatePropagation();
			props.onClose();
		};
		window.addEventListener("keydown", onKeyDown, true);
		onCleanup(() => window.removeEventListener("keydown", onKeyDown, true));
	});

	return (
		<div class={props.class} style={props.style}>
			<VideoPanelCarousel
				activeSlide={activeCarouselSlide() ?? props.videoIndex}
				setActiveSlide={(slide) => {
					setActiveCarouselSlide(slide);
					props.onVideoIndexChange?.(slide);
				}}
				videoEvidence={props.videoEvidence}
				boardId={props.boardId}
				onClose={props.onClose}
				showAddToBoardButton={props.showAddToBoardButton ?? true}
				projectId={props.projectId}
				autoPlay={props.autoPlay}
			/>
		</div>
	);
};
